import React, { useReducer } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import css from './index.module.scss';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';

const Gif = ({ stillImg, gif, className }) => {
    const [gifIsPlaying, setGifIsPlaying] = useReducer((gifIsPlaying) => (!gifIsPlaying), true);

    return (
        <span className={css.gifContainer}>
            {/* Render conditionally using style so that the switch is seamless, both imgs are already loaded - no rerendering component */}
            {/* <Image className={className} field={gif} style={{ display: gifIsPlaying ? 'block' : 'none' }} /> */}
            <div style={{ display: gifIsPlaying ? 'block' : 'none' }}>
                <LazyLoadImage className={className} threshold={100} src={gif?.value?.src} 
                alt={gif?.value?.alt && gif?.value?.alt}
                />
            </div>
            {/* <Image className={className} field={stillImg} style={{ display: gifIsPlaying ? 'none' : 'block' }} /> */}
            <div style={{ display: gifIsPlaying ? 'none' : 'block' }}>
                <LazyLoadImage className={className} threshold={100} src={stillImg?.value?.src} 
                alt={stillImg?.value?.alt && stillImg?.value?.alt}
                />
            </div>
            <button aria-label='Pause Gif'
                className={`${css.gifButton} fa ${gifIsPlaying ? 'fa-pause' : 'fa-play'}`}
                onClick={setGifIsPlaying} />
        </span>
    )
}

const ImageWrapper = ({ image, className, gif = null }) => {
    return (gif?.value?.src && gif?.value?.src.indexOf("default_image.svg") == 0) ?
        <Gif stillImg={image} gif={gif} className={className} />
        :
        // <Image field={image} className={className} />;
        <div>
            <LazyLoadImage className={className} threshold={100} src={image?.value?.src} 
            alt={image?.value?.alt && image?.value?.alt} />
        </div>
};

// export default trackWindowScroll(ImageWrapper);
export default ImageWrapper;